<div class="form-block">
    <div>
        <div fxLayout="row">
            <div role="none" (click)="toogle()" fxLayoutAlign="start center" fxFlex="50">
                <kendo-icon *ngIf="colapsed" [name]="'arrow-60-down'"></kendo-icon>
                <kendo-icon *ngIf="!colapsed" [name]="'arrow-60-up'"></kendo-icon>
                <span *ngIf="!extraReferenceType">{{documentTypeId | staticDictionaryCaption:'documentType' | async }}
                </span>
                <span>[ {{claimPhotos?.length}} ]</span>

            </div>

            <div fxLayoutAlign="end center" fxFlex="50" *ngIf="!isClaimArchived">
                <input *ngIf="canRemove" type="checkbox" [ngModel]="selectedAll" kendoCheckBox
                    (change)="onSelectAll()" />
                <button *ngIf="canRemove" kendoButton (click)="onButtonDelete()" icon="delete"
                    class="button-with-margin">
                </button>

                <button *ngIf="canChangeType" kendoButton (click)="onButtonChangePhotosType()" icon="arrow-right"
                    class="button-with-margin">
                </button>

                <kendo-switch [ngModel]="checkedAll" (valueChange)="toogleAllToExport()" class="button-with-margin">
                    {{'claims-center.claimDocumentation.addAllToExport' | translate}}
                </kendo-switch>
            </div>
        </div>
    </div>
    <div [hidden]="colapsed">

        <div *ngIf="canUpload && !isClaimArchived">
            <app-upload-files [uploadFilesSettings]="uploadFilesSettings" (uploadedEvent)="newUploadedItem($event)">
            </app-upload-files>
        </div>

        <div class="photos-container" *ngIf="!isClaimArchived">
            <app-loading-panel [isLoading]="isLoading"></app-loading-panel>

            <strong *ngIf="isError" class="error-label">{{'errors.errorWhenLoadingData' | translate}}</strong>

            <div class="selected-file" *ngFor="let file of claimPhotos">

                <div role="none" fxLayoutAlign="center center" fxLayout="column" (click)="showContent(file)">
                    <img class="img" [src]="getThumb(file)" [alt]="file.name" alt="file" />

                    <div>
                        <span class="small-info" *ngIf="!!file.originalCreationDate">
                            {{'claims-center.claimDocumentation.creationOriginalDateShort' | translate}} :
                            {{file.originalCreationDate | date: 'yyyy-MM-dd HH:mm:ss'}}
                        </span>
                        <span class="small-info" *ngIf="!file.originalCreationDate">
                            {{'claims-center.claimDocumentation.storeDateShort' | translate}} : {{file.timestamp |
                            date: 'yyyy-MM-dd HH:mm:ss'}}
                            </span>
                        <span class="small-info" *ngIf="file.fileSize > 0">({{file.fileSize | filesize}})</span>
                        <span class="small-info" *ngIf="file.createdBy"> - {{file.createdBy }}</span>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center end">
                    <div fxFlex="20">
                        <input *ngIf="canRemove" type="checkbox" [ngModel]="file.isSelected" #notification kendoCheckBox
                            (change)="onCheckboxChange($event, file.id)" />
                    </div>
                    <div fxFlex="20">
                        <kendo-badge-container *ngIf="file.isAudanetExported"
                            title="{{file.audanetExportedBy}}({{file.audanetExportedTimestamp}})">
                            <img src="./assets/img/audatex_logo.jpg" [width]="48" alt="audatex"/>

                            <kendo-badge size="small" themeColor="success" [align]="align" [position]="'inside'">
                                <kendo-icon [name]="'upload'"></kendo-icon>
                            </kendo-badge>

                        </kendo-badge-container>
                    </div>
                    <div fxFlex="45" fxLayoutAlign="end center">
                        <app-export-document-select [documentId]="file.id"></app-export-document-select>
                    </div>
                </div>

            </div>
        </div>

          <div class="photos-container" *ngIf="isClaimArchived">
            <strong>{{'claims-center.claimDocumentation.photosAreAlreadyArchived' | translate}}</strong>
          </div>

    </div>
</div>
<div kendoDialogContainer #photosDialog></div>